import React from "react";
import { Flex } from "./FlexHelpers";
import { Button, ButtonProps } from "../button/Button";
import { LinkWithCopyButton } from "./LinkWithCopyButton";


export type LinkPanelStatus = 
        {value:'loading'} |
        {value:'has-link', url:string} |
        {value:'no-link', noLinkText:string};

export type LinkPanelProps = {
    link:LinkPanelStatus,
    onCreateLink?:()=>void,
    onDeleteLink?:()=>void

}
export function LinkPanel(props: LinkPanelProps): JSX.Element 
{

    // Only run this once - requires refreshing when the component itself updates data
    return (
        <Flex flexDirection="row">
            {props.link.value === 'loading' &&
                <span>...</span>
            }

            {props.link.value !== 'loading' &&
                <>
                <Flex flexDirection="row" gap={8}>
                    {props.link.value === 'has-link' &&
                       
                        <Flex>
                            <LinkWithCopyButton
                                url={props.link.url}
                            />
                            <Button variant="destructive-text"
                                icon="interface_actions_delete" toolTipText="Slet link" onClick={props.onDeleteLink}
                            />
                        </Flex>
                    }

                    {props.link.value === 'no-link' &&
                       
                        <TextWithButton
                            text={props.link.noLinkText}
                            buttons={
                                props.onCreateLink===undefined 
                                    ? []
                                    : [{ icon: "interface_actions_link", text: 'Opret link', variant:"outlined", onClick:props.onCreateLink }]
                            }
                        />

                    }
                    </Flex>
                </>
            }
        </Flex>
    );
}

type TextWithButtonProps =
    {
        text: string,
        buttons: ButtonProps[]
    };

function TextWithButton(props: TextWithButtonProps): JSX.Element {
    return (
        <>
            {props.buttons.map((b, i) =>
                <Button key={i} {...b} />
            )}
        </>
    )
}
